module.exports = "/images/vendor/flag-icon-css/flags/4x3/pw.svg?20a1d020151e19375915c509633d5018";